/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceURIQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceURIQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceURIQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceURIQueryOperator>): ComplianceURIQueryOperator {
        let obj = Object.assign(new ComplianceURIQueryOperator(), model);
        ComplianceURIQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceURIQueryOperator>): ComplianceURIQueryOperator {
        if (!model) return null;
        return ComplianceURIQueryOperator.newInstance(<ComplianceURIQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceURIQueryOperator) {
        if (!obj) return;

        models.ComplianceURIQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceURIQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceURIQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of unique identifiers (URIs) for specific compliance standards to filter. This can be fetched from the Compliance Standards List API call.
     */
    compliance_uris: Array<string>;

}
